<template>
    <card>
        <h3 class="mb-0" slot="header">{{ $t('common.information') }}</h3>

        <ul class="list-group list-group-flush list my--3">
            <li class="list-group-item px-0" 
                    v-for="(item, index) in data" :key="index">

                <div class="row align-items-center">
                    <div class="col-md-4 title">{{ item.name }}</div>
                    <div class="col-md-8 value">{{ item.value }}</div>
                </div>
            </li>
        </ul>
    </card>
</template>

<script>
    export default {

        props: {
            value: {
                type: Object,
                required: true
            },
        },

        data() {
            let data = [
                { name: this.$t('common.username'), value: this.value.username },
                { name: this.$t('users.lastname'), value: this.value.lastname },
                { name: this.$t('users.firstname'), value: this.value.firstname },
                { name: this.$t('common.email'), value: this.value.email },
            ]
            if (this.value.role || this.value.admin) {
                data.push({ 
                    name: this.$t('common.role'),
                    value: this.value.admin ? this.$t('common.super-admin') : this.value.role.name,
                })
            }
            if (this.value.owner) {
                data.push({ 
                    name: this.$t('common.owner'),
                    value: this.value.owner.name,
                })
            }
            if (this.value.entity) {
                data.push({ 
                    name: this.$t('common.client'),
                    value: this.value.entity.name,
                })
            }
            data.push({ 
                name: this.$t('users.enac-id'),
                value: this.value.enac_id,
            })
            data.push({ 
                name: this.$t('common.active'),
                value: this.value.active ? 'Yes' : 'No',
            })
            data.push({ 
                name: this.$t('users.ldap'),
                value: this.value.source == 'ldap' || this.value.source == 'ldap2' ? 'Yes' : 'No',
            })
            return { data }
        }
    }
</script>

<style scoped>

    .title {
        color: #525f7f;
        font-size: 0.875rem;
        font-weight: 600;
    }
    .value {
        font-size: 0.875rem;
    }

</style>